export const PageKeys = {
  home: '/',
  unknown: '/404',
  nodeExplorer: '/nodes',
  groups: '/groups',
  provenanceGraph: '/graph',
  structures: '/structures'
}

export const LocalStorageKeys = {
  darkMode: 'react-aiida-dark-mode',
  restUrlBase: 'react-aiida-rest-url',
  aiidaUUIDbookmarks: 'aiida-uuid-bookmarks',
  aiidaNodeXTypePrefix: 'aiida-node-explorer-type-prefix',
  aiidaNodeXFieldUUID: 'aiida-node-explorer-field-uuid',
  aiidaNodeXExpanded: 'aiida-node-explorer-expanded',
  aiidaProvenanceRootUUID: 'aiida-provenence-graph-root-uuid',
  aiidaProvenanceDagMode: 'aiida-provenence-graph-dag-mode',
  aiidaProvenanceDagLevel: 'aiida-provenence-graph-dag-level-dist',
  aiidaStructureUUID: 'aiida-structure-uuid',
  optimadeStructureProvider: 'optimade-structure-provider',
  optimadeStructureId: 'optimade-structure-id'
}
